import { defineComponent as _defineComponent } from 'vue'
export interface Metric {
    label: string;
    value: string;
    icon?: string;
}

interface MiniCardMetricsProps {
    metrics: Metric[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniCardMetrics',
  props: {
    metrics: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})